import type { FC } from 'react';

import { Outlet } from 'react-router';

import { AskGXPanel, useAskGXAvailability } from '@/features/ai-chat';
import { useSelectedSignal } from '@/features/morning-intel';
import { useBreakpoints } from '@/shared/hooks/useBreakpoints';
export const AskGXDockedLayout: FC = () => {
  const isAskGXAvailable = useAskGXAvailability();
  const { isDesktop } = useBreakpoints();
  const selectedSignal = useSelectedSignal();
  const showDockedPanel = isAskGXAvailable && isDesktop;

  return (
    <div className={showDockedPanel ? 'flex min-h-0 flex-1' : 'contents'}>
      <div className={showDockedPanel ? 'min-w-0 flex-1 overflow-y-auto p-6' : 'contents'}>
        <Outlet />
      </div>
      {showDockedPanel && <AskGXPanel selectedSignal={selectedSignal} />}
    </div>
  );
};
